import React, { useContext, useMemo } from 'react';
import classNames from 'classnames';
import LeadContext from '../../providers/Lead/Lead.context';
import { Outlet } from 'react-router-dom';
import PortfolioSubnav from '../../../../components/PortfolioSubnav';
import { useTranslation } from 'react-i18next';
import BackLink from 'components/BackLink';
import AuthContext from 'providers/Auth/Auth.context';
import { BUYING_PORTFOLIO_ROUTE } from 'data/global';

import './ListingPreviewBuyer.styles.scss';
import './ListingPreviewBuyer.styles.responsive.scss';

type ListingPreviewBuyerProps = {
  className?: string;
};

const ListingPreviewBuyer: React.FC<ListingPreviewBuyerProps> = (props) => {
  const { className } = props;

  const { previousLocation } = useContext(AuthContext);
  const {
    dealRoom,
    listing,
    sessionId,
    unreadMessagesCount,
    canAccessDataRoom,
  } = useContext(LeadContext);

  const { t } = useTranslation();

  const classes = classNames('listing-preview-buyer', className);

  const prevTo = useMemo(() => {
    if (!previousLocation) return '../';
    const { pathname, search } = previousLocation || {};
    return pathname === BUYING_PORTFOLIO_ROUTE
      ? search
        ? `${pathname}${search}`
        : pathname
      : '..';

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={classes}>
      <BackLink to={prevTo}>{t('portfolio')}</BackLink>

      <h1>{dealRoom?.portfolioName}</h1>

      <PortfolioSubnav
        as="buyer"
        dealRoom={dealRoom}
        listing={listing}
        sessionId={sessionId}
        canAccessDataRoom={canAccessDataRoom}
        unreadMessagesCount={unreadMessagesCount}
      />

      <div className="listing-info__content">
        <Outlet />
      </div>
    </div>
  );
};

export default ListingPreviewBuyer;
